(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("ExternalEnrollments",
            {
                url: "/Enrollments",
                component: "externalEnrollments",
                PageTitle: "Enrollment Form",
                title: "sadfsd0",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
    }]);

    app.component("externalEnrollments",
        {
            templateUrl: "App/FigDotComInterestForms/Programs.html",
            controller: extEnrollCtrl,
            bindings: {
                states: "<"
            }
        });

    extEnrollCtrl.$inject = [
        "$state", "$scope", "$q", "$location", "_", "figDotComApi", "surveys", "$mdDialog"];

    function extEnrollCtrl($state, $scope, $q, $location, _, figDotComApi, surveys, $mdDialog) {
        var $ctrl = this;
        window.o = this;
        $ctrl.UI = { isSubmitting: false, loading: true, submitted: false };

        var classes = function (q) {
            return {
                "col-md-6": ["Address", "City", "State", "Zip Code", "Which program are you interested in", "What is your current ESTIMATED annual gross production?"].indexOf(q.SurveyQuestionText) === -1,
                "col-md-12": q.SurveyQuestionText === "Which program are you interested in",
                "col-md-12": q.SurveyQuestionText === "Address",
                "col-md-2": ["City", "State", "Zip Code"].indexOf(q.SurveyQuestionText) !== -1,
                "col-md-6 col-md-offset-3": q.SurveyQuestionText === "What is your current ESTIMATED annual gross production?",
                //"col-md-6": q.SurveyQuestionText === "Primary Lines of Business",
                //"col-md-1": q.SurveyQuestionText === "State",
                //"col-md-3": q.SurveyQuestionText === "City",
                //"col-md-2": q.SurveyQuestionText === "Zip Code",
            };
        };

        $ctrl.enrollment = [];
        var answers = [];
        $ctrl.surveyId = 1023;
        ng.extend($ctrl,
            {
                classes: classes,
                questionAnswered: questionAnswered,
                questionAnsweredNoText: questionAnsweredNoText,
                checkboxAnswered: checkboxAnswered,
                reloadPage: reloadPage,
                submit: submit
            });
        
        function questionAnswered(questionId, id, answer) {                 
            var a = _.find(answers, { SurveyQuestionId: questionId });

            if (a) {
                a.SurveyQuestionPossibleAnswerId = id;
                a.TextValue = answer;
            } else {
                answers.push({
                    SurveyQuestionId: questionId,
                    SurveyQuestionPossibleAnswerId: id,
                    TextValue: answer
                });
            }
        }

        function questionAnsweredNoText(questionId, id) {          
            questionAnswered(questionId, id, "default");
        }

        function checkboxAnswered(questionId, id) {         
            var obj = _.find(answers, { SurveyQuestionId: questionId, SurveyQuestionPossibleAnswerId: id });

            if (obj)
                answers.splice(answers.indexOf(obj), 1);
            else
                answers.push({
                    SurveyQuestionId: questionId,
                    SurveyQuestionPossibleAnswerId: id,
                    TextValue: "default"
                });
        }       

        function submit() {
            $ctrl.UI.isSubmitting = true;
           
            answers.forEach(function (a) {
                delete a.SurveyQuestionId;
            });
            
            figDotComApi.submit($ctrl.surveyId, answers).then(function () {                
                $ctrl.UI.submitted = true;
                $ctrl.UI.isSubmitting = false;
            }, function () {
                $mdDialog.show($mdDialog.alert().title("Form submission failed.").ok("Ok"));
                $ctrl.UI.isSubmitting = false;
            });
        }

        function reloadPage() {
            //console.log('test')
            //TODO: Glitch that makes "form completed" message appear after clicking "submit another request"
            $ctrl.UI.submitted = false;
            answers = [];
        }

        function init() {           
            var promises = [];
           
            var externalSurveyIdentifier = parseInt($location.search().id);
          
            promises.push(figDotComApi.getSurvey($ctrl.surveyId).then(function (p) {

                $ctrl.enrollment.Questions = p.Questions;
                              
                $ctrl.enrollment.Questions.forEach(function(q) {
                    if (q.SurveyQuestionType === "FigProduct") {                      
                        q.PossibleAnswers.forEach(function (a) {                              
                            if (a.PossibleAnswerId === externalSurveyIdentifier) {                                
                                questionAnswered(q.SurveyQuestionId, a.PossibleAnswerId, a.PossibleAnswerText);
                                q.PossibleAnswerId = a.PossibleAnswerId;                               
                            }
                        });
                    }
                });             
            }));

            promises.push(figDotComApi.getSalesConsultants().then(function (sc) {

                sc.forEach(function (s) {
                    s.FullName = s.FirstName + " " + s.LastName;
                });
                $ctrl.salesConsultants = sc;
                console.log(sc);
            }));

            $q.all(promises).then(function () {
                return $ctrl.UI.loading = false;
            }, function () {
                return $ctrl.UI.loading = false;
            });
          
                             
        }

        init();
    }
})(window.app, window.angular);
